//公用组件
import addUserTransfer from '@/components/addUserTransfer/index.vue';
import myTransfer from '@/components/addUserTransfer/my-transfer';
import organizationTree from '@/components/organization-tree.vue'; // 组织树 ：部门/组织
import positionSelect from '@/components/position-select.vue'; // 岗位
import selectedPersonnelNew from '@/components/selectPersonNew/selectedPersonnel';
import selectPersonUp from '@/components/selectPersonUp/selected-person';
import myEditor from '@/components/my-editor'; // 编辑器
import nonCascadeTree from '@/components/non-cascade-tree';
import home from '@/components/Home/index';


export default {
  addUserTransfer,
  myTransfer,
  organizationTree,
  positionSelect,
  selectedPersonnel: selectedPersonnelNew,
  selectedPersonnelNew,
  selectPersonUp,
  myEditor,
  nonCascadeTree,
  home,
};
